















































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { ChoiceOption } from '@/interfaces';
import DocumentTable from '@/components/orderdocs/DocumentTable.vue';
import DocumentMixin from '@/mixins/DocumentMixin';
import ProjectStatusMixin from '@/mixins/ProjectStatusMixin';

@Component({
  components: {
    DocumentTable
  }
})
export default class ProjectDetail extends Mixins(
  DetailMixin,
  DocumentMixin,
  ProjectStatusMixin
) {
  public tableCfg = FieldDefs;
  public contactList: ChoiceOption[] = [];
  public showContacts = false;
  public version = 1;
  public setStateDialogValue = false;
  public newState = {
    projecteventtype_id: 1
  };

  public loaded(rec) {
    if (this.$route.params.id === 'new') {
      this.getCustomerInfo();
    }
    if (rec.last_projecteventtype_id && rec.last_projecteventtype_id < 5) {
      this.newState.projecteventtype_id = rec.last_projecteventtype_id + 1;
    }
  }

  public async getCustomerInfo() {
    const ref: any = this.$refs.layout;
    const customerId = ref.rec.businessrelation_id;
    if (customerId) {
      const customerResponse = await this.api.getRecord(
        this.$store,
        '/businessrelations/' + customerId
      );
      const contactData = await this.api.getChoices(
        this.$store,
        '/businessrelations/' + customerId + '/contacts/choice/'
      );
      if (customerResponse) {
        // Init construction address
        const customerData: any = customerResponse.data;
        ref.rec.construction_site_address = {
          country_id: customerData.billing_address.country_id,
          postal_code: customerData.billing_address.postal_code,
          city: customerData.billing_address.city,
          street: customerData.billing_address.street
        };
        // Init contact list
        if (contactData) {
          this.showContacts = (customerData as any).is_multi_contact;
          this.contactList = contactData.records;
          if (this.contactList.length === 1) {
            // Select single contact
            ref.rec.contact_id = this.contactList[0].value;
          }
        }
      }
    } else {
      this.contactList = [];
    }
    this.version += 1;
  }

  public clearCustomerInfo() {
    const ref: any = this.$refs.layout;
    // Clear construction address
    ref.rec.construction_site_address = {
      country_id: 56
    };
    // Clear contact
    ref.rec.contact_id = null;
  }

  public async exportVatdoc(id) {
    const response = await this.api.postAction(
      this.$store,
      this.getTableCfg(this.tableCfg, 'apiUrl') + String(id) + '/export_vatdoc'
    );
  }

  public async setState(id, stateId) {
    const ref: any = this.$refs.layout;
    const response = await this.api.postAction(
      this.$store,
      this.getTableCfg(this.tableCfg, 'apiUrl') +
        String(id) +
        '/setstate?projecteventtype_id=' +
        String(stateId)
    );
    if (response) {
      this.setStateDialogValue = false;
      ref.getRecord();
    }
  }

  public mounted() {
    // Initialize contacts
    this.getCustomerInfo();
  }
}
